export function registerImageCacheSW() {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/image-cache-sw.js", { scope: "/" })
      .catch((err) => {
        console.warn("Image cache SW registration failed:", err);
      });
  });
}
